"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VendorCompanyDetailPageActions;
(function (VendorCompanyDetailPageActions) {
    VendorCompanyDetailPageActions["Loaded"] = "Loaded";
    VendorCompanyDetailPageActions["RecordUpdated"] = "RecordUpdated";
    VendorCompanyDetailPageActions["RecordAdded"] = "RecordAdded";
})(VendorCompanyDetailPageActions || (VendorCompanyDetailPageActions = {}));
exports.default = VendorCompanyDetailPageActions;
